import { MappedPerformanceTimingKeys } from './types/MappedPerformanceTimingKeys';
import { getTime } from './scriptParseEndTimes';
import { getStartTime } from './envDiagnostics';

let optics: MappedPerformanceTimingKeys;
export function getNavigationTiming(windowObj?: Window) {
    if (!optics) {
        optics = calculateNavigationTiming(Date.now(), windowObj);
    }

    return optics;
}

export function calculateNavigationTiming(
    nowTimeStamp: number,
    windowObj?: Window
): MappedPerformanceTimingKeys {
    optics = {};
    let timing: PerformanceTiming = null;
    let navigation: PerformanceNavigation = null;
    let fs = null;
    windowObj = windowObj || window;
    if (windowObj.performance) {
        timing = windowObj.performance.timing;
        navigation = windowObj.performance.navigation;
    }

    if (timing) {
        fs = timing.fetchStart;
        optics.fs = fs;
        timing.unloadEventStart && (optics.ues = (timing.unloadEventStart - fs) | 0);
        timing.unloadEventEnd && (optics.uee = (timing.unloadEventEnd - fs) | 0);
        timing.redirectStart && (optics.reds = (timing.redirectStart - fs) | 0);
        timing.redirectEnd && (optics.rede = (timing.redirectEnd - fs) | 0);
        timing.navigationStart && (optics.pref = (timing.navigationStart - fs) | 0);
        timing.domainLookupStart && (optics.dls = (timing.domainLookupStart - fs) | 0);
        timing.domainLookupEnd && (optics.dle = (timing.domainLookupEnd - fs) | 0);
        timing.connectStart && (optics.cs = (timing.connectStart - fs) | 0);
        timing.connectEnd && (optics.ce = (timing.connectEnd - fs) | 0);
        timing.secureConnectionStart && (optics.scs = (timing.secureConnectionStart - fs) | 0);
        timing.requestStart && (optics.reqs = (timing.requestStart - fs) | 0);
        timing.responseStart && (optics.ress = (timing.responseStart - fs) | 0);
        timing.responseEnd && (optics.rese = (timing.responseEnd - fs) | 0);
        timing.domLoading && (optics.doml = (timing.domLoading - fs) | 0);
        timing.domContentLoadedEventStart &&
            (optics.domcles = (timing.domContentLoadedEventStart - fs) | 0);
        timing.domContentLoadedEventEnd &&
            (optics.domclee = (timing.domContentLoadedEventEnd - fs) | 0);
        timing.domComplete && (optics.domc = (timing.domComplete - fs) | 0);
        timing.loadEventStart && (optics.les = (timing.loadEventStart - fs) | 0);
        timing.loadEventEnd && (optics.lee = (timing.loadEventEnd - fs) | 0);
    }

    if (navigation) {
        optics.nt = navigation.type;
        optics.redc = navigation.redirectCount;
    }

    getTime('bootstrap') && (optics.pe = getTime('bootstrap') - (fs || getStartTime()));
    fs && (optics.pltnav = (nowTimeStamp - fs) | 0);
    optics.pltnonav = nowTimeStamp - getStartTime();

    return optics;
}
